export default __webpack_public_path__ + "static/media/imc-inner-1.530d233d.jpg";